export const version = 'kunde-v1.20.0-SNAPSHOT-a6edc83891f270a253f69de0d9648a4fe7c4e5f0';